import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 text-center bg-black pt-20">
      <span className="inline-block py-1 px-3 rounded-full bg-blue-600/10 border border-blue-600/20 text-blue-500 text-[10px] font-bold tracking-[0.2em] uppercase mb-6">
        Error 404
      </span>
      <h1 className="text-7xl md:text-9xl font-serif font-bold text-white mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-serif font-semibold text-zinc-300 mb-4">Signal Lost</h2>
      <p className="text-zinc-400 max-w-md mb-10 text-sm leading-relaxed font-light">
        The intelligence you are looking for has been moved, archived, or does not exist.
      </p>
      <Link 
        to="/" 
        className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold uppercase tracking-widest text-[11px] transition-all shadow-lg shadow-blue-600/20"
      >
        Return to Home &rarr;
      </Link>
    </div>
  );
}